import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="d-flex flex-column mb-5" style={{ height: '100%', backgroundColor: '#f8f6f0' }}>
      <ScrollToTop />

      {/* Breadcrumb */}
      <div className="py-3 ">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 font_two">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none active text-dark ">
                  Home
                </Link>
              </li>
              <li
                className="breadcrumb-item fw_700 font-medium"
                aria-current="page"
              >
                Privacy Policy
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container flex-grow-1 py-4">

        <div className="container flex-grow-1 d-flex flex-column flex-md-row py-4 ">
          {/* Left Content */}
          <div className="col-lg-4 col-md-5 mb-4 mb-md-0">
            <h1 className="mb-3" style={{ fontSize: '2.5rem', fontWeight: '500', color: '#2c3e50', fontFamily: 'Lora' }}>
              Privacy Policy for DigiCartt
            </h1>
            <p className="text-muted mb-0 font-satoshi" style={{ fontSize: '1.1rem', lineHeight: '1.6', fontFamily: 'Satoshi, sans-serif', textAlign:'justify' }}>
                By using our Services, you consent to this Privacy Policy. If you disagree, please discontinue use of the website.            </p>
              <p className="text-muted mt-2 font-satoshi" style={{ fontSize: '0.9rem', fontWeight: '500', fontFamily: 'Satoshi, sans-serif ' }}>
                  Last Updated: January 6, 2026<br />
                  Effective Date: January 2026
              </p>
          </div>

          {/* Vertical Divider */}
          <div className="d-none d-lg-block" style={{
            padding: '0.5px',
            backgroundColor: '#112C3B4D',
            margin: '0 2rem',
            alignSelf: 'stretch'
          }}>
          </div>

          <div>
            <hr className="mt-0" />
          </div>

          {/* Right Content */}
          <div className="col-lg-8 col-md-7">
            <div className="privacy-content" style={{ lineHeight: '1.7', fontFamily: 'Satoshi, sans-serif', textAlign:'justify' }}>
                <p className="text-muted mb-4 font-satoshi" style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem'}}>
                    Welcome to DigiCartt ("we," "our," or "us"). This Privacy Policy describes how we collect, use, disclose, and protect your personal information when you visit or use our website www.digicartt.com, purchase our products, or interact with our services (collectively, the "Services").
                </p>
              {/* Section 1: Information We Collect */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  1. Information We Collect
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  <strong>a. Information You Provide</strong>
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We collect personal information you provide directly, including when you:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc' }}>
                  <li>Create an account or make a purchase</li>
                  <li>Subscribe to newsletters or marketing materials</li>
                  <li>Contact customer support</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  This may include:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc' }}>
                  <li>Name, email address, phone number</li>
                  <li>Billing and shipping address</li>
                  <li>Payment details (processed securely; we do not store card numbers)</li>
                  <li>Purchase history and order details</li>
                  <li>Communication preferences</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  <strong>b. Information Automatically Collected</strong>
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We automatically collect:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '1rem', listStyleType: 'disc' }}>
                  <li>IP address, browser type, and device information</li>
                  <li>Pages visited, referral URLs, and time spent</li>
                  <li>Cookie identifiers, advertising IDs, and approximate location (city/state/country)</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0', fontWeight: '500' }}>
                  <strong>c. Information from Third Parties</strong>
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  We may combine information from:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>Affiliate or marketing partners</li>
                  <li>Data analytics and advertising providers</li>
                  <li>Payment gateways or shipping providers</li>
                </ul>
              </div>

              {/* Section 2: Use of Information */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  2. Use of Information
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We use your personal information to:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>Process and fulfill digital product orders (DigiVision Collection)</li>
                  <li>Redirect to affiliate partner websites for physical art purchases (Canvas Collection)</li>
                  <li>Communicate order confirmations and support responses</li>
                  <li>Improve and personalize your shopping experience</li>
                  <li>Send marketing messages (with consent)</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              {/* Section 3: Affiliate Disclosure */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  3. Affiliate Disclosure (FTC Compliance)
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  This site participates in affiliate marketing programs.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  When you click an affiliate link and make a purchase, we may earn a commission — at no additional cost to you.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  Affiliate transactions are handled by third-party partners, each governed by their own privacy policies. We do not control their data handling practices, so we encourage you to review their privacy terms before purchasing.
                </p>
              </div>

              {/* Section 4: Legal Basis for Processing */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  4. Legal Basis for Processing (GDPR)
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  If you are an EU/EEA or UK resident, we process your personal data on the following lawful bases:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0', listStyleType: 'disc' }}>
                  <li>Contractual necessity: to process your purchases</li>
                  <li>Legitimate interests: to improve our Services and ensure security</li>
                  <li>Consent: for marketing and cookies</li>
                  <li>Legal obligations: to comply with regulatory requirements</li>
                </ul>
              </div>

              {/* Section 5: Sharing and Disclosure */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  5. Sharing and Disclosure of Information
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  We do not sell your personal data.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We share data only with:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Service providers — payment processors, analytics, hosting, or email platforms</li>
                  <li>Affiliate partners — when you click their links for purchases</li>
                  <li>Law enforcement or regulators — when required by law</li>
                  <li>Marketing & analytics partners — for limited, aggregated insights</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  All third parties are contractually bound to protect your data and use it solely for intended purposes.
                </p>
              </div>

              {/* Section 6: Cookies and Tracking */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  6. Cookies, Tracking, and Targeted Advertising
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We and our partners use cookies and similar technologies to:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Remember preferences and login sessions</li>
                  <li>Analyze site usage and performance</li>
                  <li>Show relevant ads on our and others' websites</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  You can control cookies via your browser settings or through our Cookie Settings link in the footer.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  We honor Global Privacy Control (GPC) and "Do Not Track" signals where legally required (California, EU/EEA, UK).
                </p>
              </div>

              {/* Section 7: Data Retention */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  7. Data Retention
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We retain personal data only as long as necessary for:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Fulfilling orders or legal obligations</li>
                  <li>Maintaining business records or resolving disputes</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Retention periods depend on data type, sensitivity, and purpose.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  After this period, data is securely deleted or anonymized.
                </p>
              </div>

              {/* Section 8: Data Security */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  8. Data Security
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We implement industry-standard security controls, including:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>SSL encryption for data transmission</li>
                  <li>Restricted access to authorized personnel</li>
                  <li>Secure cloud infrastructure and regular audits</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Despite precautions, no system is 100% secure. You transmit data at your own risk.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  If a data breach occurs, we will notify affected users and authorities as required by law.
                </p>
              </div>

              {/* Section 9: International Data Transfers */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  9. International Data Transfers
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  If you access our Services outside the U.S., your data may be processed in the U.S. or other countries with different data protection laws.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We rely on:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0' }}>
                  <li>Standard Contractual Clauses (SCCs)</li>
                  <li>The EU-U.S. Data Privacy Framework (DPF)</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginTop: '0.5rem', marginBottom: '0' }}>
                  to ensure adequate data protection levels.
                </p>
              </div>

              {/* Section 10: Your Privacy Rights */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  10. Your Privacy Rights
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  <strong>For U.S. Residents</strong>
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Residents of California, Virginia, Colorado, Connecticut, Utah, and Nevada may have rights to:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Access or delete personal data</li>
                  <li>Correct inaccuracies</li>
                  <li>Opt out of "sales" or "sharing" for targeted advertising</li>
                  <li>Know categories of information collected and disclosed</li>
                  <li>Non-discrimination for exercising rights</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '1rem' }}>
                  To exercise these rights, contact us at [insert email] or use our "Do Not Sell or Share My Information" link in the footer.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  <strong>For EU/EEA & UK Residents (GDPR Rights)</strong>
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  You may:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Access or request a copy of your data</li>
                  <li>Request correction or deletion</li>
                  <li>Object to processing or restrict use</li>
                  <li>Withdraw consent anytime</li>
                  <li>Request data portability</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  To exercise rights, email [insert email] with subject "GDPR Request." We will verify your identity and respond within 30 days.
                </p>
              </div>

              {/* Section 11: Marketing Communications */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  11. Marketing Communications
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We may send emails about:
                </p>
                <ul style={{ fontSize: '1rem', color: '#555', paddingLeft: '1.2rem', marginBottom: '0.5rem', listStyleType: 'disc' }}>
                  <li>Order confirmations and digital downloads</li>
                  <li>Product updates or special offers (with consent)</li>
                </ul>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  You can unsubscribe anytime via the email footer link.
                </p>
              </div>

              {/* Section 12: Children's Privacy */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  12. Children's Privacy
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Our Services are not intended for children under 16, and we do not knowingly collect their data.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  If we learn that we have inadvertently collected data from a minor, we will delete it immediately.
                </p>
              </div>

              {/* Section 13: User-Generated Content */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  13. User-Generated Content & Reviews
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  If you post reviews or feedback publicly on our website or social media, this content may be visible to others.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  By posting, you grant DigiCartt a non-exclusive right to display or share your submission for marketing purposes (crediting you where applicable).
                </p>
              </div>

              {/* Section 14: Cooperative Marketing */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  14. Cooperative Marketing and Data Partners
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We may occasionally share limited, non-sensitive customer data (such as email or ZIP code) with cooperative marketing databases to improve campaign performance.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  You can opt out by emailing [insert email] with the subject "Opt-Out of Data Sharing."
                </p>
              </div>

              {/* Section 15: Financial Incentives */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  15. Financial Incentives (CCPA)
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  From time to time, DigiCartt may offer discounts or promotional codes to users who join our email list or create an account.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Participation is voluntary, and you can withdraw at any time.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  We do not assign a monetary value to your data beyond the promotional offer provided.
                </p>
              </div>

              {/* Section 16: Data Retention, Access & Deletion */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  16. Data Retention, Access & Deletion Requests
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  You can request access, correction, or deletion of your data by contacting us.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Requests will be verified before processing.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  If we must retain certain information for legal or transactional reasons, we'll inform you accordingly.
                </p>
              </div>

              {/* Section 17: Contact Us */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  17. Contact Us
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem', fontWeight: '500' }}>
                  DigiCartt
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Email: support@digicartt.com
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Address: [Insert Business Address]
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  Data Protection Officer (for EU/UK): [Insert if applicable]
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  Phone: [Optional]
                </p>
              </div>

              {/* Section 18: Changes to Privacy Policy */}
              <div className="mb-4">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  18. Changes to This Privacy Policy
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  We may update this Privacy Policy periodically.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0.5rem' }}>
                  The latest version will always appear on this page with the updated "Last Updated" date.
                </p>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  Your continued use of our Services after updates means you accept the revised terms.
                </p>
              </div>

              {/* Section 19: Consent */}
              <div className="mb-0">
                <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#2c3e50' }}>
                  19. Consent
                </h3>
                <p style={{ fontSize: '1rem', color: '#555', marginBottom: '0' }}>
                  By using our website or making a purchase, you consent to this Privacy Policy and all data handling practices described herein.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
